import type { FormInstance }   from 'antd';
import { AppFormComponent }    from 'components/App/AppForm';
import React                   from 'react';
import { Form }                from 'antd';
import { Col }                 from 'antd';
import Row                     from 'components/App/Row';
import { observer }            from 'mobx-react';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import handleFormError         from 'utils/handleFormError';
import Select                  from 'components/App/IntlSelect';
import { EN, FR }              from 'constants/Languages';
import currentSession          from 'utils/currentSession';
import UserMeModel             from 'models/UserMeModel';

const { Option } = Select;

interface UserLanguagePreferenceFormProps {
  onSuccess?: (languagePreference: string) => void;
}

@observer
class UserLanguagePreferenceForm extends AppFormComponent<UserLanguagePreferenceFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public componentDidMount() {
    let languagePreference = EN.value;

    if (navigator.language === FR.value) {
      languagePreference = FR.value;
    }

    this.formRef.current?.setFieldsValue({
      languagePreference,
    });
  }

  public render() {
    return (
      <Form ref={this.formRef}>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item
              // help={getFieldError('languagePreference') || ''}
              label={<FormattedMessageWrapper id="Séléctionner une langue" />}
              labelCol={{ span: 24 }}
              name="languagePreference"
              // validateStatus={getFieldError('languagePreference') ? 'error' : ''}
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>
                <Option value={EN.value}>{EN.label}</Option>
                <Option value={FR.value}>{FR.label}</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { onSuccess } = this.props;

    const userMe = new UserMeModel();
    userMe.setId(currentSession.user.user_id);

    const values = await this.formRef.current?.validateFields();

    try {
      await userMe.patch({
        languagePreference: values.languagePreference,
      });

      if (onSuccess) {
        currentSession.user.user_informations = {
          ...currentSession.user.user_informations,
          language_preference: values.languagePreference,
        };

        await currentSession.refresh();

        onSuccess(values.languagePreference);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };
}

export default UserLanguagePreferenceForm;
